import React from 'react';
import { PatientCareCenterNoteChargesBody } from 'PatientCareCenter/Note/Charges'
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import { PatientCareCenterNoteChargesDiagnosis } from './Diagnosis';


class PatientCareCenterNoteWpCharges extends React.Component {

    render() {
        return (
            <PatientCareCenterNoteSection id='charges' name='Charges' refProp={this.props.refProp} level={5}>
                <PatientCareCenterNoteChargesDiagnosis />
                <PatientCareCenterNoteChargesBody />
            </PatientCareCenterNoteSection>
        );
    }
}

export { PatientCareCenterNoteWpCharges };

